import { atom } from 'jotai'

export type ReviewPricingFeatures = {
  stackedDiscounts: boolean
}

/**
 * The feature flags the pricing atoms need. An atom cannot read a hook, so the
 * `ReviewPricing` step component reads the flags and writes them here, and the
 * derived atoms take them from this one place.
 *
 * Defaults to everything off, which is what an unresolved flag reads as too.
 */
export const reviewPricingFeaturesAtom = atom<ReviewPricingFeatures>({
  stackedDiscounts: false
})
